import { Modal, UnstyledButton } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import * as AppStore from './../state/app-store'

import * as Selectors from './../state/selectors'
import { setMetric } from '../state/app-store'
import RadioButtonGroup from './RadioButtonGroup'

const useUnit = () => {
	const dispatch = AppStore.useAppDispatch()

	const setUnit = (unit: string | undefined): void => {
		if (unit) {
			dispatch(setMetric(unit))
		}
	}

	return { setUnit }
}

// renders in the footer bottom bar (next to FeedbackWidget) — quiet text
// button that opens the units modal
const UnitsSelector: React.FC = () => {
	const [opened, { open, close }] = useDisclosure(false)
	const { setUnit } = useUnit()

	const unit = AppStore.useAppSelector(Selectors.unitSelector)

	const unitOptions = [
		{ display: 'km + metres', value: 'metric' },
		{ display: 'miles + feet', value: 'imperial' },
	]

	return (
		<>
			<Modal opened={opened} onClose={close} title="Units" size="md">
				<p>
					Set the units you want to use and see displayed throughout the site.
				</p>
				<h4>Distances + heights</h4>
				<RadioButtonGroup<string>
					items={unitOptions}
					value={unit}
					onChange={(val) => setUnit(val)}
					nullable={false}
					size="sm"
				/>
			</Modal>

			<UnstyledButton onClick={() => open()} className="footer-action-link">
				<span style={{ fontWeight: unit === 'metric' ? 700 : 400 }}>km</span>
				{' / '}
				<span style={{ fontWeight: unit === 'imperial' ? 700 : 400 }}>
					miles
				</span>
			</UnstyledButton>
		</>
	)
}

export default UnitsSelector
